import { ReactNode } from "react";
import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type BreadcrumbsConfirmationModalProps = {
  content: ReactNode;
  onConfirm: () => void;
};

const BreadcrumbsConfirmationModal = create(function BreadcrumbsConfirmationModal({
  onConfirm,
  content,
}: BreadcrumbsConfirmationModalProps) {
  const modal = useModal();

  const handleOnConfirm = () => {
    modal.resolve();
    modal.hide();
    onConfirm();
  };

  return (
    <ConfirmationModal
      title="Are you sure you want to go back?"
      confirmationButtonLabel="Go back"
      confirmationButtonVariant="dangerPrimary"
      onConfirm={handleOnConfirm}
    >
      <ConfirmationModalMessage>{content}</ConfirmationModalMessage>
    </ConfirmationModal>
  );
});

export const showBreadcrumbsConfirmationModal = (props: BreadcrumbsConfirmationModalProps) =>
  show(BreadcrumbsConfirmationModal, props);
